import { clsx } from 'clsx'
import { observer } from 'mobx-react-lite'
import { ItemCard } from 'page/catalog/ItemCard/ItemCard'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './ItemsList.module.scss'

export const ItemsList = observer(() => {
  const demo = useDemo()
  const { stand, items } = demo
  const { reloading } = demo.form
  const className = clsx(css.list, stand ? css.stand : css.regular, reloading && css.busy)

  return (
    <div className={className}>
      {items.map(it => <ItemCard key={it.item_id} item={it} />)}
    </div>
  )
})
